<template>
  <div>
    <!-- <el-carousel height="500px" v-if="type == 'homes' && bannerList.length > 0">
      <el-carousel-item>
        <img
          :src="bannerList[0].cxfmtpurl"
          alt=""
          style="height: 100%; width: 100%"
        />
      </el-carousel-item>
    </el-carousel> -->
    <el-carousel height="500px">
      <el-carousel-item v-for="item in bannerList" :key="item.lpid">
        <img :src="item.cxfmtpurl" alt="" style="height: 100%; width: 100%" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'HomeSwiper',
  //   接收数据
  props: ['type'],
  data() {
    return {}
  },
  created() {
    this.getBannerImg({
      ctid: this.$store.state.ctid,
      pageSize: 6,
      pageNum: 1,
      newbqId: 6,
      xctype: 8,
    })
  },
  methods: {
    ...mapMutations(['getBannerImg']),
  },
  computed: { ...mapState(['bannerList']) },
}
</script>
